import React, { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { getStoredCity } from '../utils/locationPreference';
import { normalizeCityKey } from '../utils/cityUtils';

const SelectedCityContext = createContext({
  selectedCity: 'Mumbai',
  cityKey: 'mumbai',
  refreshFromStorage: () => {}
});

export function SelectedCityProvider({ children }) {
  const [selectedCity, setSelectedCity] = useState(getStoredCity);

  const sync = useCallback(() => {
    setSelectedCity(getStoredCity());
  }, []);

  useEffect(() => {
    const onChange = (e) => {
      if (e?.detail?.city) {
        setSelectedCity(e.detail.city);
      } else {
        sync();
      }
    };
    window.addEventListener('bfp:city-changed', onChange);
    const onStorage = (ev) => {
      if (ev.key === 'bfp_selected_city') sync();
    };
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('bfp:city-changed', onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, [sync]);

  const cityKey = normalizeCityKey(selectedCity);
  const value = { selectedCity, cityKey, refreshFromStorage: sync };

  return <SelectedCityContext.Provider value={value}>{children}</SelectedCityContext.Provider>;
}

export function useSelectedCity() {
  return useContext(SelectedCityContext);
}
